<div class="main">
    <app-header
    
    >
    </app-header>
  
    <div
      class="d-flex flex-column align-items-center justify-content-start main-top"
    >
      <div
        id="surveyElement"
        class="d-flex flex-row align-items-center justify-content-center m-auto px-4"
      ></div>
      <div
        class="d-flex flex-row align-items-center justify-content-center m-auto"
      >
      <div class="thank-you">
        <h4>Thank you for completing the form.</h4>
        <button class="btn btn-primary mt-3" (click)="navigateToHome()">Done</button>
      </div>
    </div>
  </div>
